import { getTestBed } from '@angular/core/testing';
import { KrameriusService } from './../services/kramerius.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-drafts',
  templateUrl: './drafts.component.html',
  styleUrls: ['./drafts.component.scss']
})
export class DraftsComponent implements OnInit {

  drafts: any[];

  constructor(private krameriusService: KrameriusService) { }

  ngOnInit() {
    const limit = 10000;
    //https://kramerius.difmoe.trinera.cloud/search/api/client/v7.0/search?fl=pid,title.search,model&q=model:draft_*&sort=created%20desc&rows=200
    //this.krameriusService.getSolrResult('fl=PID,dc.title&q=fedora.model:draft&sort=created_date%20desc&rows=200').subscribe(
    this.krameriusService.getSolrResult(`fl=pid,title.search,model&q=model:draft_*&sort=created%20desc&rows=${limit}`).subscribe(
      result => {
        this.drafts = result['response']['docs'];
      }
    );
  }



}
